import React from 'react';
import { connect } from 'react-redux';
import { contactSelectors, currentUserSelectors } from '@lifesize/nucleus';
import CallButtons from 'components/CallButtons/CallButtons';
import actions from 'actions/Contact';
import { hooks } from '@lifesize/clients.sdk';
import { isCallDisconnected } from 'utils/call-utils';

const mapStateToProps = (state, ownProps) => {
  const contact = contactSelectors.getContactByDialStringGenerator(state)(ownProps.extension);
  const selfDialString = currentUserSelectors.myInfo(state).dialString;
  const isSelfContact = ownProps.extension === selfDialString;
  const isInCall = !isCallDisconnected(ownProps.activeCall);
  let isCallable;

  if (!isInCall && contact && contact.isCallable && !isSelfContact) {
    isCallable = true;
  } else {
    isCallable = !isSelfContact && !isInCall;
  }

  return {
    isCallable
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  handleVideoCall: () => dispatch(actions.startVideoCall(ownProps.extension)),
  handleAudioCall: () => dispatch(actions.startAudioCall(ownProps.extension))
});

const ConnectedComponent = connect(mapStateToProps, mapDispatchToProps)(CallButtons);

const FunctionalWrapper = (props) => {
  const activeCall = hooks.useCallState();

  return <ConnectedComponent {...props} activeCall={activeCall} />;
};
export { ConnectedComponent as CallButtonsContainer };
export default FunctionalWrapper;
